
export const ALLOWLIST = [
	'0xaA399Dd981051891f7725311b580FDe83bE30FbB',
].map(e => e.toLowerCase())
